var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.23,112a16,16,0,0,0-16,16V256a16,16,0,0,0,8.45,14.1l84,45a16,16,0,0,0,15.11-28.2l-75.56-40.48V128A16,16,0,0,0,272.23,112Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.23,48c-101,0-185.42,72.38-204.12,168L49.34,188.16a16,16,0,1,0-26.53,17.89L62.2,264.48a16,16,0,0,0,22.21,4.33l58.44-39.4A16,16,0,1,0,125,202.88l-25,16.83C116.78,140,187.62,80,272.23,80c97,0,176,78.95,176,176s-79,176-176,176A174.83,174.83,0,0,1,147.8,380.44l-22.63,22.62A206.59,206.59,0,0,0,272.23,464c114.69,0,208-93.31,208-208S386.92,48,272.23,48Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBackground);
export default __webpack_public_path__ + "static/media/icon-background.0a85d9c0.svg";
export { ForwardRef as ReactComponent };